import React from 'react';
import { Link } from 'react-router';

import Nutrient from '~/components/lawns/digital-soil-test/nutrient';
import NutrientElement from '~/components/lawns/digital-soil-test/nutrient-element';
import OrganicMatterGraph from '~/components/lawns/digital-soil-test/organic-matter-graph';
import SoilPhGraph from '~/components/lawns/digital-soil-test/soil-ph-graph';
import CationExchangeGraph from '~/components/lawns/digital-soil-test/cation-exchange-graph';
import DigitalSoilTestSubheading from '~/components/lawns/digital-soil-test/common/digital-soil-test-subheading';
import { helpCenterRoute, shedArticleRoute } from '~/routes';

import styles from '~/components/lawns/digital-soil-test/digital-soil-test.module.scss';

const DigitalSoilTest = ({ digitalSoilTest, onClose, showDescription }) => {
  const {
    cationExchange,
    isCalciumPpmLimiting,
    isMagnesiumPpmLimiting,
    isPhosphorusPpmLimiting,
    isPotassiumPpmLimiting,
    isSoilPhLimiting,
    isSulfurPpmLimiting,
    organicMatter,
  } = digitalSoilTest;
  return (
    <div className={styles.predictiveSoilTest}>
      <DigitalSoilTestSubheading>
        Projected soil properties
      </DigitalSoilTestSubheading>
      <div className={styles.graphs}>
        <OrganicMatterGraph organicMatter={organicMatter} />
        <SoilPhGraph isSoilPhLimiting={isSoilPhLimiting} />
        <CationExchangeGraph cationExchange={cationExchange} />
      </div>
      <DigitalSoilTestSubheading>
        Projected nutrient levels
      </DigitalSoilTestSubheading>
      <div className={styles.nutrientsContainer}>
        <Nutrient
          name="Potassium"
          symbol="K"
          description="Vital to grass’ ability to endure stress"
          color="#B9B7CF"
          isLimiting={isPotassiumPpmLimiting}
        />
        <Nutrient
          name="Phosphorus"
          symbol="P"
          description="An energy source in plant metabolism"
          color="#D1D5DE"
          isLimiting={isPhosphorusPpmLimiting}
        />
        <Nutrient
          name="Sulfur"
          symbol="S"
          description="A key player in lowering soil pH"
          color="#ADC178"
          isLimiting={isSulfurPpmLimiting}
        />
        <Nutrient
          name="Calcium"
          symbol="Ca"
          description="Vital for maintaining plant structure and soil pH"
          color="#C3A68E"
          isLimiting={isCalciumPpmLimiting}
        />
        <Nutrient
          name="magnesium"
          symbol="Mg"
          description="Critical nutrient in chlorophyll, keeps plants green"
          color="#CB997E"
          isLimiting={isMagnesiumPpmLimiting}
        />
      </div>

      <DigitalSoilTestSubheading>
        additional nutrients
      </DigitalSoilTestSubheading>

      <div className={styles.additionalNutrientsBlock}>
        <div className={styles.additionalNutrientsContainer}>
          <div className={styles.additionalNutrient}>
            <NutrientElement
              className={styles.nutrientElement}
              name="iron"
              symbol="Fe"
            />
            iron
          </div>
          <div className={styles.additionalNutrient}>
            <NutrientElement
              className={styles.nutrientElement}
              name="boron"
              symbol="B"
            />
            boron
          </div>
          <div className={styles.additionalNutrient}>
            <NutrientElement
              className={styles.nutrientElement}
              name="copper"
              symbol="Cu"
            />
            copper
          </div>
          <div className={styles.additionalNutrient}>
            <NutrientElement
              className={styles.nutrientElement}
              name="manganese"
              symbol="Mn"
            />
            manganese
          </div>
          <div className={styles.additionalNutrient}>
            <NutrientElement
              className={styles.nutrientElement}
              name="zinc"
              symbol="Zn "
            />
            zinc
          </div>
        </div>
        <div className={styles.learnMoreBubbleContainer}>
          <div className={styles.learnMoreBubble}>
            <img
              className={styles.soilDishIcon}
              src="/icons/soil-dish-icon.svg"
              alt="Soil in petri dish and magnifying glass"
              width="80"
              height="69"
            />
            <p>Want to learn more about nutrients?</p>
            <Link
              onClick={onClose}
              to={shedArticleRoute({
                category: 'sunday-way',
                slug: 'decoding-your-soil-test',
              })}
            >
              see scientific details
            </Link>
          </div>
        </div>
      </div>

      {Boolean(showDescription) && (
        <>
          <h3 className={styles.soilTestTitle}>
            Where are my soil test results?
          </h3>
          <p className={styles.soilTestText}>
            Your soil test results will be ready approximately 4-6 weeks of our
            lab receiving it. If you are still waiting on results, please{' '}
            <Link to={helpCenterRoute()}>visit our help center</Link>. Once your
            analysis is complete, your new soil profile will display above and
            will include exact measurements related to your soil profile and
            details on how Sunday can help.
          </p>
        </>
      )}
    </div>
  );
};

export default DigitalSoilTest;
